import { BoxModes } from 'Types/common';
import Box from '../Box';
import * as Styled from './styles';
import { ReferralBoxProps } from './types';

const ReferralBox = ({ profits }: ReferralBoxProps): JSX.Element => {
  const { notStarted, lastStep, paid } = profits;

  return (
    <Styled.Container justify="center">
      <Box profit={notStarted} mode={BoxModes.notStarted} />
      <Box profit={lastStep} mode={BoxModes.lastStep} />
      <Box profit={paid} mode={BoxModes.paid} />
    </Styled.Container>
  );
};

export default ReferralBox;
